import React, { FC } from 'react';

import {
  makeStyles,
  createStyles,
  createMuiTheme,
} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Typography, Link } from '@material-ui/core';

import useAppMenu from '../hooks/appmenu/useAppMenu';

/**
 * Menu Models
 */
interface MenuLink {
  label: string;
  path: string;
}

interface MenuSection {
  label: string;
  links: MenuLink[];
}

interface Menu {
  sections: MenuSection[];
}

/**
 * Menu Component
 */

const useStyles = makeStyles(() => createStyles({
  appMenuBox: {
    display: 'inline-block',
    width: '15rem',
    height: '60rem',
    paddingLeft: '2rem',
    paddingTop: '2rem',
    backgroundColor: '#DCDCDC',
  },
  sectionLabel: {
    paddingTop: '.75rem',
    paddingBottom: '.75rem',
  },
  linkContainer: {
    '&:hover': {
      backgroundColor: '#F6CD76',
    },
  },
  link: {
    paddingTop: '.5rem',
    paddingBottom: '.5rem',
    cursor: 'pointer',
    color: '#0F4B8D',
  },
}));

const AppMenu: FC = () => {
  const theme = createMuiTheme();
  const classes = useStyles(theme);

  const menu: Menu = useAppMenu();

  return (
    <Grid container className={classes.appMenuBox}>
      { menu.sections.map((menuItem, idx1) => (
        <div key={`outer${idx1 + 100}`}>
          <Grid item className={classes.sectionLabel}>
            <Typography variant="h5">{menuItem.label}</Typography>
          </Grid>
          { menuItem.links.map((link, idx2) => (
            <Grid item key={`inner${idx2 + 1000}`} className={classes.linkContainer}>
              <Link
                href={link.path}
                className={classes.link}
              >
                <Typography variant="body1">{link.label}</Typography>
              </Link>
            </Grid>
          )) }
        </div>
      )) }
    </Grid>
  );
};

export default AppMenu;
